import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "./AuthContext";

export default function StaffRoute({ children }) {
  const { user } = useAuth();

  if (!user) return <Navigate to="/login" />;
  if (user.ruolo !== "ROLE_STAFF") return <div>Accesso negato</div>;

  return children;
}
